import { createReducer, createActions } from 'reduxsauce';
import get from 'lodash-es/get';
import { USER_ROLES } from '@services/minte';

const { Types, Creators } = createActions({
  setLoggedIn: ['token'],
  setLoggedOut: null,
  setUserLoadRequest: null,
  setRefreshAuthRequest: null,
  setUser: ['user'],
  changePaymentDetails: ['payload'],
  setKeySignatureSigned: ['isSigned'],
  setUserSettings: ['settings']
});

export const AuthTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  token: null,
  me: null,
  paymentDetails: {
    cardNumber: '',
    expiryDate: '',
    cvc: '',
    coupon: ''
  },
  keyRelease: {},
  settings: {
    isPropertySettingActive: true
  }
};

/* ------- Selectors --------- */
export const AuthSelectors = {
  selectIsLoggedIn: state => !!state.auth.token,
  selectIsPMUser: state =>
    get(state, 'auth.me.role') === USER_ROLES.PROPERTY_MANAGER,
  selectCurrentUser: state => state.auth.me,
  selectCurrentPropertyId: state => get(state, 'auth.me.propertyID'),
  selectIsKeyReleaseSigned: state => get(state, 'auth.me.isKeyReleaseSigned'),
  selectHasPaymentMethod: state => !!get(state, 'auth.me.customerID'),
  selectPaymentDetails: state => state.auth.paymentDetails,
  selectKeySignature: state => state.auth.keyRelease,
  selectHasActivePropertySetting: state =>
    state.auth.settings.isPropertySettingActive,
  selectUserProperties: state => get(state, 'auth.me.properties', [])
};

/* -------- Reducers ---------- */
export const setLoggedIn = (state, { token }) => {
  return {
    ...state,
    token
  };
};

export const setLoggedOut = () => {
  return {
    ...INITIAL_STATE
  };
};

export const setUser = (state, { user }) => ({
  ...state,
  me: user
});

export const changePaymentDetails = (state, { payload }) => {
  return {
    ...state,
    paymentDetails: {
      ...state.paymentDetails,
      ...payload
    }
  };
};

export const setKeySignatureSigned = (state, { isSigned }) => {
  return {
    ...state,
    me: {
      ...state.me,
      isKeyReleaseSigned: isSigned
    }
  };
};

export const setUserSettings = (state, { settings }) => {
  return {
    ...state,
    settings: {
      ...state.settings,
      ...settings
    }
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOGGED_IN]: setLoggedIn,
  [Types.SET_LOGGED_OUT]: setLoggedOut,
  [Types.SET_USER]: setUser,
  [Types.CHANGE_PAYMENT_DETAILS]: changePaymentDetails,
  [Types.SET_KEY_SIGNATURE_SIGNED]: setKeySignatureSigned,
  [Types.SET_USER_SETTINGS]: setUserSettings
});
